import { render } from "./DoctorWelcome.vue?vue&type=template&id=6ea7c53d&scoped=true&ts=true"
import script from "./DoctorWelcome.vue?vue&type=script&lang=ts"
export * from "./DoctorWelcome.vue?vue&type=script&lang=ts"

import "./DoctorWelcome.vue?vue&type=style&index=0&id=6ea7c53d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea7c53d"]])

export default __exports__